import { Icon } from '@chakra-ui/react';
import { BsCurrencyDollar } from 'react-icons/bs';
import React from 'react';

function PercentIcon() {
  return <Icon as={BsCurrencyDollar} color="gray.500" />;
}

export default PercentIcon;
